//import react
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'

//import react router dom
import { Switch, Route } from "react-router-dom";

//import component Register
import Register from './pages/Register';

//import component Login
import Login from './pages/Login';

//import component Register
import Dashboard from './pages/Dashboard';

//import component UserManagement
import UserManagement from './pages/UserManagement';

//import component ForgotPassword
import ForgotPassword from './pages/ForgotPassword';

//import component Callback
import Callback from './pages/Callback';

//import component Activation
import Activation from './pages/Activation';

function App() {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/user-management" component={UserManagement} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/forgotpassword" component={ForgotPassword} />
        <Route exact path="/callback" component={Callback} />
        <Route exact path="/activation" component={Activation} />
      </Switch>
    </div>
  );
}

export default App;